<template>
  <div class="attachment-preview" :class="spacingClass">
    <div
      v-if="isImage && !imageLoadError"
      class="attachment-thumb-wrapper mb-2"
    >
      <VueCustomTooltip label="Preview">
        <img
          :src="file.path"
          :alt="file.name"
          class="attachment-thumb"
          loading="lazy"
          @click="showPreview = true"
          @error="imageLoadError = true"
        />
      </VueCustomTooltip>
    </div>
    <div v-else-if="isVideo" class="attachment-thumb-wrapper mb-2">
      <video :src="file.path" controls class="attachment-video"></video>
    </div>

    <a
      :href="file.path"
      target="new_blank"
      rel="noopener noreferrer"
      class="p-2 rounded link-download d-flex flex-row justify-content-between"
      style="color: rgba(136, 136, 136, 0.68)"
    >
      <span>
        <strong>{{ file.id }}</strong
        >:
        <span
          v-text="
            file.name.substring(0, 40) + (file.name.length > 40 ? '... ' : '')
          "
        ></span>
        {{ file.size }}
      </span>
      <svg width="16" height="16" class="mt-1">
        <image
          xlink:href="../../../src/assets/icons/download.svg"
          width="16"
          height="16"
        />
      </svg>
    </a>

    <AttachmentLightbox
      v-if="isImage && !imageLoadError"
      v-model="showPreview"
      :src="file.path"
      :name="file.name"
    />
  </div>
</template>

<script>
import AttachmentLightbox from "./attachmentLightbox.vue";

const IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "svg",
  "bmp",
  "avif",
  "ico",
];
const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg"];

export default {
  name: "AttachmentPreview",
  components: {
    AttachmentLightbox,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    spacingClass: {
      type: String,
      default: "my-2",
    },
  },
  data() {
    return {
      showPreview: false,
      imageLoadError: false,
    };
  },
  computed: {
    extension() {
      const name = (this.file?.name || "").split("?")[0];
      const parts = name.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },
    isImage() {
      return IMAGE_EXTENSIONS.includes(this.extension);
    },
    isVideo() {
      return VIDEO_EXTENSIONS.includes(this.extension);
    },
  },
};
</script>

<style scoped>
.attachment-thumb-wrapper {
  max-width: 340px;
  width: fit-content;
  position: relative;
}
.attachment-thumb-wrapper::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 4px;
  /* background-color: rgba(5, 9, 17, 0.35); */
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s;
}
.attachment-thumb-wrapper:hover::after {
  opacity: 1;
}
.attachment-thumb {
  /* width: 340px; */
  max-width: 100%;
  max-height: 260px;
  object-fit: contain;
  display: block;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background-color: #f0f0f0bb;
}
.attachment-video {
  width: 340px;
  max-width: 100%;
  display: block;
  border-radius: 4px;
}
</style>

